import { render, staticRenderFns } from "./scoreEntryClass.vue?vue&type=template&id=61ecff6e&scoped=true"
import script from "./scoreEntryClass.vue?vue&type=script&lang=js"
export * from "./scoreEntryClass.vue?vue&type=script&lang=js"
import style0 from "./scoreEntryClass.vue?vue&type=style&index=0&id=61ecff6e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61ecff6e",
  null
  
)

export default component.exports